import { getPlural } from "./languageUtil";

function getSelectedLabel(singleItemLabel: string, selectedItemsCount: number): string {
  return `${singleItemLabel}${getPlural(selectedItemsCount)} sélectionné${getPlural(selectedItemsCount)}`;
}

export enum multiAutoClassNames {
  SDEAPPS_MULTI_AUTOCOMPLETE = "SDEAppsMultiAutocomplete",
  AUTOCOMPLETE_CSS_CHECKBOX = "autocomplete-css-checkbox",
  CHECKED = "checked",
  UNCHECKED = "unchecked",
}

const multiSelectWithCheckboxesSxProps = {
  [`& .${multiAutoClassNames.AUTOCOMPLETE_CSS_CHECKBOX}`]: {
    minWidth: "24px",
    width: "24px",
    height: "24px",
    m: 0,
    p: 0,
    mr: 1,
    ml: -1,
    [`&.${multiAutoClassNames.CHECKED}`]: {
      backgroundImage:
        "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill='%23017CAC'><path d='M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'></path></svg>\")",
    },
    [`&.${multiAutoClassNames.UNCHECKED}`]: {
      backgroundImage:
        "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill='%2365718A'><path d='M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'></path></svg>\")",
    },
  },
};

export const multiAutoUtil = {
  getSelectedLabel,
  multiAutoClassNames,
  multiSelectWithCheckboxesSxProps,
};
